import React from 'react'
import classNames from 'classnames'
import {
  Card, CardText, CardGroup, CardFooter,
  ListGroup, ListGroupItem, Badge
} from 'reactstrap'
import ExternalContentModal from './ExternalContentModal'
import InformativeBanner from './InformativeBanner'
import UrlsPagination from './UrlsPagination'


const CheckerResults = ({ sentences, urls, content }) => {
  const [compareUrl, setCompareUrl] = React.useState(null)
  const [openedModal, setOpenedModal] = React.useState(false)

  React.useEffect(() => {
    if (Array.isArray(urls) && urls.length > 0 && urls[0].target) {
      setCompareUrl(urls[0].target)
    }
  }, [urls])

  function onToggleUrl(url) {
    setCompareUrl(url)
  }

  function toggleModal() {
    setOpenedModal(prev => !prev)
  }

  function isCopiedFromURL(searchGroup) {
    return searchGroup.some(search => search.target === compareUrl)
  }

  return (
    <React.Fragment>
      <Card>
        <CardGroup>
          <Card>
            <InformativeBanner sentences={sentences} />

            <CardText>
              {
                (sentences || []).map((sentence) => (
                  <span
                    key={sentence.content.substring(0, 10).replace(' ', '')}
                    className={classNames({
                      'mx-1': isCopiedFromURL(sentence.search || []),
                    })}
                    style={{
                      backgroundColor: isCopiedFromURL(sentence.search || [])
                        ? 'lightcoral'
                        : 'transparent'
                    }}
                  >
                    {`${sentence.content} `}
                  </span>
                ))
              }
            </CardText>
          </Card>

          <Card outline className="ml-4">
            <ListGroup flush>
              {
                (sentences || []).map((sentence) => (
                  <ListGroupItem key={sentence.content.substring(0, 10).replace(' ', '')}>
                    <div className="d-flex justify-content-between">
                      <span className="mr-1 truncate">
                        {sentence.content}
                      </span>

                      {
                        isCopiedFromURL(sentence.search || []) ? (
                          <Badge
                            color="danger"
                            className="float-right"
                            onClick={() => toggleModal()}
                            style={{ cursor: 'pointer' }}
                          >
                            Comparar
                          </Badge>
                        ) : (
                          <Badge className="float-right" color="success">
                            Único
                          </Badge>
                        )
                      }
                    </div>
                  </ListGroupItem>
                ))
              }
            </ListGroup>

            {
              urls.length > 0 && (
                <CardFooter>
                  <UrlsPagination urls={urls} onToggleUrl={onToggleUrl} />
                </CardFooter>
              )
            }

            <ExternalContentModal
              openModal={openedModal}
              url={compareUrl}
              doms={urls}
              content={content}
              onToggleModal={toggleModal}
            />
          </Card>
        </CardGroup>
      </Card>
    </React.Fragment>
  )
}

export default CheckerResults
